/**
 * @flow
 */
import React from 'react';
import { connect } from 'react-redux';
import { Select } from 'semantic-ui-react';
import { range, get } from 'lodash';
import type { Dispatch } from '../../../../../type';

const mapStateToProps = ({ invoice }, { name }) => {
    const product = get(
        invoice.get('selectedProducts'),
        name.replace('quantity', 'entity'),
    );
    let max = 100;
    if (product) {
        max = product.quantity;
    }
    return {
        max,
    };
};

type QuantityFieldProps = {
    meta: Object,
    dispatch: Dispatch,
    max: number,
};

const QuantityField = ({
    meta,
    dispatch,
    max,
    ...props
}: QuantityFieldProps) => {
    // since range doesn't include end, do max + 1
    const options = range(1, max + 1).map(item => ({
        value: item,
        text: item,
    }));
    return <Select {...props} options={options} />;
};

export default connect(mapStateToProps)(QuantityField);
